export default __webpack_public_path__ + "static/step0403-3083e85a4e5069dbe2349bd0a242fb9f.jpg";